import { render, staticRenderFns } from "./MarketFeedback.vue?vue&type=template&id=0ebc19f5&scoped=true"
import script from "./MarketFeedback.vue?vue&type=script&lang=js"
export * from "./MarketFeedback.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ebc19f5",
  null
  
)

export default component.exports